var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-form",
                {
                  ref: "myForm",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    }
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary", fixed: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", layout: "", "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                layout: "",
                                "align-center": "",
                                wrap: "",
                                "align-start": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClosed({})
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v("close")
                                  ])
                                ],
                                1
                              ),
                              _c("v-toolbar-title", [
                                _vm._v(
                                  "\n                Generar Encomienda\n              "
                                )
                              ])
                            ],
                            1
                          ),
                          !_vm.loading
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-editar",
                                      attrs: {
                                        type: "submit",
                                        disabled:
                                          _vm.disabledBtn || _vm.disabledForm
                                      }
                                    },
                                    [_vm._v("Guardar Cambios")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "cardnew pt-5",
                        attrs: { align: "center" }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { "grid-list-md": "" } },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { align: "left" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "" } },
                                          [
                                            _c(
                                              "h2",
                                              { staticClass: "h2_title" },
                                              [_vm._v("Generar Encomienda")]
                                            ),
                                            _c("v-divider"),
                                            !_vm.loading
                                              ? _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      sm12: "",
                                                      layout: "",
                                                      wrap: "",
                                                      "pa-4": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: "Código",
                                                            type: "text",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "123"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despanumero,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despanumero",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despanumero"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              "Actividad Despacho",
                                                            type: "text",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "home_repair_service"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.data
                                                                .nombre_add,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.data,
                                                                "nombre_add",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "data.nombre_add"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("DatePicker", {
                                                          attrs: {
                                                            label:
                                                              "Fecha Envio",
                                                            required: "",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despafecha_envia,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despafecha_envia",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despafecha_envia"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: "Usuario",
                                                            type: "text",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "person"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .usuario.nombre,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi
                                                                  .usuario,
                                                                "nombre",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.usuario.nombre"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label: "Courier",
                                                            items:
                                                              _vm.listApi
                                                                .courriers,
                                                            "item-value":
                                                              "configid",
                                                            "item-text":
                                                              "configvalor",
                                                            "prepend-icon":
                                                              "home_repair_service",
                                                            "return-object": "",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .courrier,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "courrier",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.courrier"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              "Orden Seguimiento (Obligatorio)",
                                                            type: "text",
                                                            rules: [
                                                              _vm.rules
                                                                .seguimiento
                                                            ],
                                                            "prepend-icon":
                                                              "list_alt",
                                                            required: "",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despaseguimiento,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despaseguimiento",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despaseguimiento"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label:
                                                              "Localidad (Obligatorio)",
                                                            "prepend-icon":
                                                              "flag",
                                                            items:
                                                              _vm.listApi
                                                                .localidades,
                                                            rules: [
                                                              _vm.rules
                                                                .localidad
                                                            ],
                                                            "item-value":
                                                              "locaid",
                                                            "item-text":
                                                              "locaname",
                                                            required: "",
                                                            "return-object": "",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .localidad,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "localidad",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.localidad"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label: "Tecnico",
                                                            "prepend-icon":
                                                              "person",
                                                            items:
                                                              _vm.listApi
                                                                .tecnicos,
                                                            "item-value":
                                                              "tecnicoid",
                                                            "item-text":
                                                              "tecniconame",
                                                            disabled: "",
                                                            "return-object": ""
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .tecnico,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "tecnico",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.tecnico"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              "Observación",
                                                            counter: "100",
                                                            type: "text",
                                                            rules: [
                                                              _vm.rules
                                                                .observacion
                                                            ],
                                                            "prepend-icon":
                                                              "feedback",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despaobs,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despaobs",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despaobs"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          sm4: "",
                                                          layout: "",
                                                          "justify-space-between":
                                                            "",
                                                          "align-center": "",
                                                          wrap: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { sm2: "" }
                                                          },
                                                          [
                                                            _c("v-checkbox", {
                                                              attrs: {
                                                                label: "Costo",
                                                                disabled:
                                                                  _vm.disabledForm
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.handleValor
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .despacargo_sino,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "despacargo_sino",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.despacargo_sino"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              sm7: "",
                                                              md8: "",
                                                              lg9: "",
                                                              xl10: "",
                                                              layot: "",
                                                              "justify-end": ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                counter: 11,
                                                                label: "Valor",
                                                                "prepend-icon":
                                                                  "local_atm",
                                                                type: "number",
                                                                min: "1",
                                                                max: "99999999",
                                                                rules: [
                                                                  _vm.rules
                                                                    .precio
                                                                ],
                                                                disabled:
                                                                  _vm.disabledFieldValue ||
                                                                  _vm.disabledForm,
                                                                items:
                                                                  _vm.listApi
                                                                    .estados
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.handleFormatValue
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .despacargo_valor,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "despacargo_valor",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.despacargo_valor"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("DatePicker", {
                                                          attrs: {
                                                            label:
                                                              "Fecha Recepción",
                                                            disabled:
                                                              _vm.disabledForm
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despafecha_recibe,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despafecha_recibe",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despafecha_recibe"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: "Receptor",
                                                            type: "text",
                                                            disabled:
                                                              _vm.disabledForm,
                                                            "prepend-icon":
                                                              "person"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .despareceptor,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "despareceptor",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.despareceptor"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("br")
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }